// EN
export const hotelRatesManager = {
  perNight: "/ nuit",
  roomFallback: "Chambre #{id}",

  header: {
    eyebrow: "Tarifs principaux",
    title: "Tarifs de l'hôtel",
    subtitle:
      "Créez des tarifs de base et appliquez-les à une ou plusieurs chambres. Les tarifs dérivés se synchronisent avec le channel manager.",
    newMain: "Nouveau tarif principal",
  },
  states: {
    loading: "Chargement des tarifs…",
    emptyTitle: "Aucun tarif pour le moment",
    emptySubtitle:
      "Créez le premier tarif principal pour commencer à gérer les prix et à les synchroniser avec le channel manager.",
    createFirst: "Créer le premier tarif",
  },
  card: {
    mainBadge: "Principal",
    occupancy: "Occ. {count}",
    minStay: "Min. {count} nuit | Min. {count} nuits",
    editRate: "Modifier le tarif",
    deleteRate: "Supprimer le tarif",
    rooms: "Chambres",
    syncedTooltip: "Synchronisé avec le channel manager",
    removeSyncedTooltip: "Retirer (attention : channel manager)",
    removeRoomTooltip: "Retirer de cette chambre",
    add: "Ajouter",
    selectRoom: "Sélectionner une chambre",
    derivedBadge: "Dérivé",
    derivedFrom: "de {name}",
    sameNameHint: "Il existe un autre « {name} » avec un autre prix ou d’autres conditions. Chaque carte se modifie séparément.",
    editDerived: "Modifier le tarif dérivé",
    deleteDerived: "Supprimer le tarif dérivé",
  },
  derived: {
    toggle: "Tarifs dérivés",
    empty:
      "Aucun tarif dérivé pour le moment. Créez-en un pour Booking.com, Airbnb ou des OTA spécifiques.",
    newDerived: "Nouveau tarif dérivé",
  },
  common: {
    allRooms: "toutes les chambres",
    cancel: "Annuler",
    saving: "Enregistrement…",
    creating: "Création…",
    saveChanges: "Enregistrer les modifications",
    removeAll: "Tout effacer",
  },
  mainModal: {
    editTitle: "Modifier le tarif principal",
    newTitle: "Nouveau tarif principal",
    nameLabel: "Nom",
    namePlaceholder: "Ex. Tarif standard, Week-end…",
    priceLabel: "Prix par nuit",
    occupancyLabel: "Occupation",
    minStayLabel: "Séjour minimum (nuits)",
    maxStayLabel: "Séjour maximum (nuits)",
    validityLabel: "Validité",
    permanent: "Permanent",
    dateRange: "Plage de dates",
    from: "Du",
    to: "Au",
    descriptionLabel: "Description (facultatif)",
    descriptionPlaceholder: "Notes internes sur ce tarif…",
    searchPlaceholder: "Rechercher une chambre…",
    selectAllShort: "Tout",
    noResults: 'Aucun résultat pour « {query} »',
    noRoomsAvailable: "Aucune chambre disponible",
    editInfo: "Les modifications s’appliqueront à {rooms} de cette carte.",
    createRate: "Créer le tarif",
  },
  derivedModal: {
    editTitle: "Modifier le tarif dérivé",
    newTitle: "Nouveau tarif dérivé",
    subtitle: "Dérivé de {name} · {price}",
    nameLabel: "Nom du tarif dérivé",
    namePlaceholder: "Ex. Booking.com, Airbnb, Sans petit-déjeuner…",
    nameHint: "Ce nom identifie le tarif dans le channel manager.",
    adjustTypeLabel: "Type d'ajustement",
    percentage: "Pourcentage",
    fixedAmount: "Montant fixe",
    adjustValueLabel: "Valeur de l'ajustement",
    adjustValueHint: "(négatif = remise)",
    resultPriceLabel: "Prix résultant",
    baseLabel: "Base",
    applyToRooms: "Appliquer aux chambres",
    onlyMainRooms: "Seules les chambres ayant le tarif principal sont affichées.",
    noRoomsWithMain: "Le tarif principal n'est encore appliqué à aucune chambre.",
    selectAll: "Tout sélectionner",
    editInfo:
      "La modification mettra à jour l'ajustement sur {rooms} qui ont ce tarif dérivé.",
    createDerived: "Créer le tarif dérivé",
  },
  removeModal: {
    title: "Retirer de la chambre",
    syncWarnTitle: "Ce tarif est synchronisé avec le channel manager",
    syncWarnBody:
      "Le retirer peut {break} des tarifs dans Channex pour cette chambre. Vérifiez le channel manager avant de continuer.",
    syncWarnBreak: "rompre la synchronisation",
    confirmText: "Cette action retirera le tarif {rate} de la chambre {room}.",
    roomLabel: "Chambre",
    rateLabel: "Tarif",
    statusLabel: "Statut",
    syncedWithChannex: "Synchronisé avec Channex",
    removing: "Retrait…",
    removeAnyway: "Je comprends, retirer quand même",
    confirm: "Retirer de la chambre",
  },
  deleteModal: {
    title: "Supprimer le tarif",
    warnTitle: "Cette action est irréversible",
    warnBody: "Le tarif {rate} sera retiré de {rooms}.",
    roomsCount: "{count} chambre | {count} chambres",
    syncedWarn:
      "Certaines chambres sont synchronisées avec Channex. Cela peut affecter la synchronisation des tarifs.",
    confirmLabel: "Saisissez {name} pour confirmer",
    deleting: "Suppression…",
    confirm: "Supprimer définitivement",
  },
  toasts: {
    loadError: "Erreur lors du chargement des tarifs de l'hôtel",
    mainCreated: "Tarif créé dans {count} chambre | Tarif créé dans {count} chambres",
    createdPartial: "{ok} créés, {fail} en échec",
    mainCreateFailAll: "Le tarif n'a pu être créé dans aucune chambre",
    mainUpdated: "Tarif mis à jour",
    updatedPartial: "{ok} mis à jour, {fail} en échec",
    mainUpdateFail: "Impossible de mettre à jour le tarif",
    derivedCreated:
      "Tarif dérivé créé dans {count} chambre | Tarif dérivé créé dans {count} chambres",
    derivedCreateFail: "Impossible de créer le tarif dérivé",
    derivedUpdated: "Tarif dérivé mis à jour",
    derivedUpdateFail: "Impossible de mettre à jour le tarif dérivé",
    roomAddedMain: "Tarif ajouté à {room}",
    addRateError: "Erreur lors de l'ajout du tarif",
    noMainRate: "Cette chambre n'a pas le tarif principal. Ajoutez-le d'abord.",
    roomAddedDerived: "Tarif dérivé ajouté à {room}",
    addDerivedError: "Erreur lors de l'ajout du tarif dérivé",
    rateRemoved: "Tarif retiré de {room}",
    removeError: "Erreur lors du retrait du tarif",
    rateDeleted: "Tarif supprimé",
    deletedPartial: "{ok} supprimés, {fail} en échec",
    deleteError: "Erreur lors de la suppression",
  },
  errors: {
    invalidRange: "Sélectionnez une plage de dates valide",
    startAfterEnd: "La date de début ne peut pas être postérieure à la date de fin",
    minStayRange: "Séjour minimum : {minStay} nuits, mais la plage en compte {nights}",
  },
};
